import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'heesundpeters',
} as IModuleProps;
